module.exports = __webpack_public_path__ + "img/fishImg.be5cd6c5.jpg";